import React, { Component } from "react";
import LayoutOperation from "../../../components/layout_operation";
import {  Input, Dropdown, Menu, Modal, Form } from "antd";
import moment from "moment";
import Api from "../../../services/ServiceApi";

// const { Option } = Select;

class PhotoReportID extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      title: "Folder Name",
      select_id: null,
      data: [
        {
          file_name: "Paragon Photo Report 01",
          size: 3.6,
        },
        {
          file_name: "Paragon Photo Report 02",
          size: 3.2,
        },
        {
          file_name: "Paragon Photo Report 03",
          size: 3.4,
        },
        {
          file_name: "Paragon Photo Report 04",
          size: 4.2,
        },
        {
          file_name: "Paragon Photo Report 05",
          size: 4.4,
        },
        {
          file_name: "Paragon Photo Report 06",
          size: 3.8,
        },
        {
          file_name: "Paragon Photo Report 07",
          size: 3,
        },
        {
          file_name: "Paragon Photo Report 08",
          size: 3.02,
        },
      ],
    };
  }

  componentDidMount() {
    document.title = this.state.title;
    console.log(this.props.match.params);
  }

  handleAdd(values) {
    values.last_modified = moment(new Date()).format("LL");
    values.file_size = 0;
    var data = this.state.data;
    data.unshift(values);
    this.setState({
      visible: false,
      data,
    });
  }

  handleRename(values) {
    var data = this.state.data;
    data[this.state.select_id].file_name = values.file_name;
    this.setState({
      data,
      visible_rename: false,
    });
  }

  onModal(name, mode, visible) {
    if (visible === false) {
      this.formRef.current.resetFields();
    }

    if (name === "folder") {
      this.setState({
        visible: visible,
        mode,
      });
    } else {
      this.setState({
        visible_sub: visible,
        mode,
      });
    }
  }

  async onRenameFolder(index, item) {
    var form = await item;
    this.setState({
      visible_rename: true,
      select_id: index,
    });
    this.formRef.current.setFieldsValue({
      file_name: form.file_name,
    });
  }

  onSelectPhoto(filename) {
    this.setState({
      visible_photo: true,
      select_id: filename,
    });
  }

  renderModalPhoto() {
    const { visible_photo, select_id } = this.state;
    return (
      <Modal
        title={""}
        centered
        visible={visible_photo}
        footer={null}
        className="custom-modal"
        closable={false}
        onCancel={() => this.setState({ visible_photo: false })}
      >
        <div style={{ backgroundColor: "#E9EDF4", height: "500px" }}></div>

        <div className="d-flex justify-content-between mt-2">
          <span className="font-thai-sb fs-18">{select_id}.jpg</span>
          <a className="font-thai-sb fs-18 c-blue">
            <img
              src={Api.absoluteUrl("/icon/download_dropdown.svg")}
              className="mr-2"
            />
            Download
          </a>
        </div>
      </Modal>
    );
  }

  renderModalRename() {
    const { visible_rename } = this.state;
    return (
      <Modal
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            Rename Folder
          </span>
        }
        centered
        visible={visible_rename}
        footer={null}
        closable={false}
      >
        <Form
          onFinish={(values) => this.handleRename(values)}
          ref={this.formRef}
          layout="vertical"
        >
          <Form.Item
            name="file_name"
            label="Folder Name"
            rules={[{ required: true, message: "Folder name is required" }]}
          >
            <Input
              className="font-mont-r fs-12"
              type="text"
              size="large"
              placeholder="Please input"
            />
          </Form.Item>
          <Form.Item className="mb-0 text-center">
            <button
              type="reset"
              onClick={() => this.setState({ visible_rename: false })}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button className="btn btn-success">Add</button>
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  render() {
    const { title, data } = this.state;

    return (
      <LayoutOperation active={3}>
        <div className="wrapper-header d-flex" style={{ height: "188px" }}>
          <div className="container-fluid">
            <div className="row align-items-center mt-3">
              <div className="col-3">
                <img
                  src={Api.absoluteUrl("/icon/photo_report_white.svg")}
                  className="mr-3"
                />
                <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b fs-20">
                  {title}
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="wrapper-body">
          <div className="container-fluid">
            <div className="card-table-ma" style={{ marginTop: "-115px" }}>
              <div style={{ padding: "30px" }}>
                <Input.Search
                  placeholder="Search file name"
                  onSearch={(value) => console.log(value)}
                  style={{ width: 200 }}
                />

                <div className="d-flex justify-content-between my-4">
                  <h3 className="font-mont-b fs-16 c-blue text-uppercase mb-0">
                    {title}
                  </h3>
                  <a className="font-thai-sb fs-18 c-blue">
                    <img
                      src={Api.absoluteUrl("/icon/download_dropdown.svg")}
                      className="mr-2"
                    />
                    Download All
                  </a>
                </div>

                <div className="row">
                  {data.map((item, index) => (
                    <div className="col-2">
                      <div className="card-photo">
                        <a onClick={() => this.onSelectPhoto(item.file_name)}>
                          <div
                            style={{ background: "#E9EDF4", height: "90px" }}
                          ></div>
                        </a>
                        <h6 className="font-thai-sb fs-18 mb-0">
                          {item.file_name}.jpg
                        </h6>
                        <div className="d-flex justify-content-between">
                          <span className="font-thai-sb fs-16">
                            {item.size} MB
                          </span>

                          <Dropdown
                            overlay={
                              <Menu>
                                <Menu.Item key="0">
                                  <a
                                    onClick={() =>
                                      this.onRenameFolder(index, item)
                                    }
                                  >
                                    <img
                                      src={Api.absoluteUrl(
                                        "/icon/rename_dropdown.svg"
                                      )}
                                      className="mr-2"
                                    />
                                    Rename
                                  </a>
                                </Menu.Item>
                                <Menu.Item key="1">
                                  <a>
                                    <img
                                      src={Api.absoluteUrl(
                                        "/icon/download_dropdown.svg"
                                      )}
                                      className="mr-2"
                                    />
                                    Download
                                  </a>
                                </Menu.Item>
                                <Menu.Item key="2">
                                  <a className="c-red">
                                    <img
                                      src={Api.absoluteUrl(
                                        "/icon/delete_dropdown.svg"
                                      )}
                                      className="mr-2"
                                    />
                                    Delete
                                  </a>
                                </Menu.Item>
                              </Menu>
                            }
                            trigger={["click"]}
                          >
                            <a
                              className="ant-dropdown-link c-blue"
                              onClick={(e) => e.preventDefault()}
                            >
                              <svg
                                className="bi bi-three-dots"
                                width="1em"
                                height="1em"
                                viewBox="0 0 16 16"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </a>
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.renderModalRename()}
        {this.renderModalPhoto()}
      </LayoutOperation>
    );
  }
}

export default PhotoReportID;
